import { ContentChild, Directive } from '@angular/core';
import { ColumnHeaderComponent } from '@app/shared/components/organisms/table/column-header/column-header.component';

@Directive({
  selector: 'appRow, tr[appRow]',
  standalone: false,
})
export class RowDirective {
  @ContentChild(ColumnHeaderComponent) header?: ColumnHeaderComponent;
}
